export default __webpack_public_path__ + "static/media/actions.29f91866.svg";